var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9643FBAD-C49B-4675-A9E5-21E47C7D428D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-367.000000, -185.000000)",
    fill: "#7C809B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(367.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contract",
    transform: "translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3743832,0 C13.1139466,0.000887781818 13.7134133,0.610795455 13.7142857,1.36363636 L13.7142857,1.36363636 L13.7142857,3.75745736 L6.82059215,10.7530185 C6.76441392,10.8100142 6.72428666,10.8810369 6.7040485,10.9591619 L6.7040485,10.9591619 L5.72197676,14.7526634 C5.68150054,14.9092685 5.72581505,15.0758168 5.83834591,15.1901634 C5.95087677,15.30451 6.11470079,15.3494318 6.26840574,15.3078835 L6.26840574,15.3078835 L9.97058421,14.3082386 C10.0466516,14.287642 10.1159148,14.2469815 10.1715696,14.1903409 L10.1715696,14.1903409 L13.7141113,10.5852273 L13.7141113,16.6363636 C13.7134133,17.3892045 13.1139466,17.9991122 12.3742088,18 L12.3742088,18 L1.33990248,18 C0.600164652,17.9991122 0.000872330109,17.3892045 -1.55697677e-12,16.6363636 L-1.55697677e-12,16.6363636 L-1.55697677e-12,1.36363636 C0.000872330109,0.610795455 0.600164652,0.000887781818 1.33990248,0 L1.33990248,0 Z M7.31191753,12 L8.57142857,13.8938577 L6.85714286,14.5714286 L7.31191753,12 Z M14.0793719,5.14285714 L16.2857143,7.34891535 L9.91952401,13.7142857 L7.71428571,11.4889084 L14.0793719,5.14285714 Z M14.8059643,4.65309106 C15.2995247,4.16257118 16.0966503,4.16339313 16.589389,4.65473492 L16.589389,4.65473492 L16.7737962,4.839173 C17.2658774,5.33248743 17.2658774,6.13122604 16.7737962,6.62454042 L16.7737962,6.62454042 L16.5412328,6.85714286 L14.5714286,4.88700856 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditContract);
export default ForwardRef;